import React from 'react';
import TextAreaAutosize from 'react-textarea-autosize';
import PropTypes from 'prop-types';
import InfoBubble from '../info-bubble';

const DEFAULT_EDITMODE_DELAY = 100;
export default class NoteInfoBubble extends InfoBubble {
  constructor(props) {
    super(props);

    this.inputChangeHandler = this.inputChangeHandler.bind(this);
    this.inputBlurHandler = this.inputBlurHandler.bind(this);
    this.inputKeyDownHandler = this.inputKeyDownHandler.bind(this);
    this.clickContentHandler = this.clickContentHandler.bind(this);
    this.inputRefHandler = this.inputRefHandler.bind(this);

    const initialEditing = props.editable && props.initialEditing;

    this.state = {
      editValue: props.content,
      editing: initialEditing,
    };
  }

  // Switch editing mode after a delay
  // This method is used to fix instant toggling after input blur events etc
  setEditingWithDelay(e, delay = DEFAULT_EDITMODE_DELAY) {
    const callbackKey = `_editable_${e}_after_delay`;
    const callback = this[callbackKey] || (() => {
      this.setEditing(e);
    });
    this[callbackKey] = callback;

    setTimeout(callback, delay);
  }

  isEditing() {
    return this.state.editing;
  }

  setEditing(b) {
    const e = this.state.editing;
    if (e === b) {
      return;
    }
    let { editValue } = this.state;
    if (b) {
      editValue = this.getContentString();
    } else if (this.props.onUpdateContent) {
      if (editValue && editValue.trim) {
        editValue = editValue.trim();
      }
      this.props.onUpdateContent(editValue);
    }
    this.setState({ editValue, editing: b });
  }

  toggleEditing() {
    this.setEditing(!this.isEditing());
  }

  toggleEditingWithDelay(delay = DEFAULT_EDITMODE_DELAY) {
    this.setEditingWithDelay(!this.isEditing(), delay);
  }

  // overridden
  createOptionEventHandler(option, eventType) {
    const handler = super.createOptionEventHandler(option, eventType);

    if (option === 'edit' && eventType === 'press') {
      return () => {
        let res = true;
        if (handler) {
          res = handler();
        }
        if (res === false) {
          return;
        }
        this.toggleEditingWithDelay();
      };
    }
    return handler;
  }

  getContentString() {
    const content = this.getContent();
    let contentString = content;
    if (!contentString) {
      contentString = '';
    }
    if (typeof (contentString) !== 'string') {
      contentString = contentString.toString();
    }
    return contentString;
  }

  focusInput() {
    const ref = this.getInputRef();
    if (ref) {
      ref.focus();
    }
  }

  getInputRef() {
    return this.inputRef;
  }
  setInputRef(ref) {
    this.inputRef = ref;
  }

  /* Event handlers */

  inputRefHandler(ref) {
    if (ref) {
      ref.setAttribute('placeholder', this.props.editPlaceholder);
      ref.focus();
    }
    this.setInputRef(ref);
  }

  inputBlurHandler() {
    this.setEditing(false);
  }

  inputChangeHandler(evt) {
    const editValue = evt.target.value;
    this.setState({ editValue });
  }

  inputKeyDownHandler(evt) {
    const kc = evt.keyCode;
    // <enter> confirms comment
    // <shift + enter> adds new line
    if (kc === 13 && !evt.shiftKey) {
      evt.preventDefault();

      this.setEditing(false);
      return false;
    }
    return true;
  }

  clickContentHandler() {
    this.setEditing(true);
  }

  /* Render */

  renderOptions() {
    // Override in parent component ?
    if (this.props.onRenderOptions) {
      return this.props.onRenderOptions(this);
    }
    const { editable, removable } = this.props;
    if (!editable && !removable) {
      return null;
    }

    return (
      <div>
        { editable ? this.renderOptionButton('icon-pencil-outline', 'edit') : null }
        { removable ? this.renderOptionButton('icon-trash', 'remove') : null }
      </div>
    );
  }

  renderInput() {
    return (
      <div className="info-bubble__content note-info-bubble__textarea-container">
        <TextAreaAutosize
          className="note-info-bubble__textarea"
          placeholder={this.props.editPlaceholder}
          onChange={this.inputChangeHandler}
          onBlur={this.inputBlurHandler}
          onKeyDown={this.inputKeyDownHandler}
          inputRef={this.inputRefHandler}
          value={this.state.editValue || ''}
        />
      </div>
    );
  }

  renderContentContainerAttributes() {
    if (!this.props.editable) {
      return null;
    }
    return {
      onClick: this.clickContentHandler,
    };
  }

  renderContentContainer() {
    if (this.state.editing) {
      return this.renderInput();
    }
    this.setInputRef(null);
    return super.renderContentContainer();
  }
}

NoteInfoBubble.defaultProps = {
  editPlaceholder: '',
  closable: true,
  editable: true,
  removable: true,
};

NoteInfoBubble.propTypes = {
  editable: PropTypes.bool,
  removable: PropTypes.bool,

  onUpdateContent: PropTypes.func,

  initialEditing: PropTypes.bool,
  editPlaceholder: PropTypes.string,

};



// WEBPACK FOOTER //
// ./js/components/configuration/note-info-bubble.jsx